import React from 'react';
import { Sparkles, Layers, Zap } from 'lucide-react';
export function BrandValues() {
  const values = [{
    icon: Sparkles,
    text: 'Buttery-soft technical fabrics'
  }, {
    icon: Layers,
    text: 'Sculpting, second-skin fit'
  }, {
    icon: Zap,
    text: 'Studio to street versatility'
  }];
  return <section className="bg-cream py-16 md:py-24 px-6" data-id="element-38">
      <div className="max-w-6xl mx-auto" data-id="element-39">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-40">
          {values.map((value, idx) => <div key={idx} className="text-center" data-id="element-41">
              <value.icon className="w-12 h-12 mx-auto mb-4 text-rust stroke-[1]" data-id="element-42" />
              <p className="text-espresso uppercase tracking-widest text-sm" data-id="element-43">
                {value.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}